/**
 * Formats a date into a string using predefined formats.
 *
 * @param dateInput - The input date (ISO string, timestamp, or Date object)
 * @param format - Desired output format:
 *  - 'short' → dd.MM.yy
 *  - 'long'  → dd-MM-yyyy
 *
 * @returns Formatted date string or empty string if invalid
 */
export const formatDate = (dateInput, format = 'long') => {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
        return '';
    }
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    if (format === 'short') {
        // dd.MM.yy
        const yy = String(date.getFullYear()).slice(-2);
        return `${dd}.${mm}.${yy}`;
    }
    // default: dd-MM-yyyy
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
};
